export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="hero-band hero-image relative overflow-hidden"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12 pt-32 md:pt-40 pb-16 md:pb-20 relative z-10 text-center opus-fade-up">
        <h1
          data-testid="hero-title"
          className="font-display uppercase leading-[1.02]"
          style={{
            color: "var(--opus-white)",
            fontSize: "clamp(2.2rem, 5.5vw, 4.4rem)",
            letterSpacing: "0.06em",
            fontWeight: 500,
          }}
        >
          Downloads <span className="italic font-light opacity-90">&</span> Resources
        </h1>
        <div className="mt-6 flex items-center justify-center">
          <span className="opus-rule" style={{ background: "rgba(255,255,255,0.5)" }} />
        </div>
        <p
          data-testid="hero-tagline"
          className="font-display uppercase mt-7 max-w-4xl mx-auto"
          style={{
            color: "rgba(255,255,255,0.95)",
            fontSize: "clamp(1.4rem, 2.6vw, 2.3rem)",
            lineHeight: 1.2,
            letterSpacing: "0.05em",
            fontWeight: 400,
          }}
        >
          Tools to keep teams moving forward
        </p>
      </div>
    </section>
  );
}
